import { BaseModel } from '@ag-common-lib/lib/models/base.model';

export enum TemplateColorSettingKeys {
  title = 'title',
  description = 'description',
  color = 'color',
  isActive = 'isActive',
}

export class TemplateColorSetting extends BaseModel {
  [TemplateColorSettingKeys.title]: string;
  [TemplateColorSettingKeys.description]: string;
  [TemplateColorSettingKeys.color]: string;
  [TemplateColorSettingKeys.isActive]: boolean = true;
}
